/**
* description:
* File of container LoginSmsTokenForm Component (Dumb)
*
* data : 2017-08-03
*/

import { mapActions } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessage from '@/components/Login/LoginErrorMessage';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginSmsTokenForm',

  components: {
    LoginErrorMessage, SmallLoadingSpinner,
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      SMSCode: null,
      passwordHidden: true,
    };
  },

  beforeMount() {
    this.resetSMSCode();
  },

  methods: {
    ...mapActions(['validateSMSCode', 'undoLoginState']),
    returnToNumberInput() {
      this.undoLoginState('initial');
    },
    submitSMSCode() {
      const SMSCode = this.SMSCode;
      this.validateSMSCode({ SMSCode });
    },
    resetSMSCode() {
      this.SMSCode = null;
    },
    togglePasswordVisibility() {
      if (this.passwordHidden) {
        document.querySelector('.login-form__input--password').type = 'text';
        this.passwordHidden = false;
      } else {
        document.querySelector('.login-form__input--password').type = 'password';
        this.passwordHidden = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginSmsTokenForm/component.js